import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import NegativeToast from './NegativeToast';

const ErrorToast = ({ error, name, operation }) => {
  const intl = useIntl();
  return (
    <NegativeToast className="aridhia-error-toast" icon="times circle">
      <FormattedMessage id="toast.error" values={{ name, operation: intl.formatMessage({ id: operation }) }} />
      {error}
    </NegativeToast>
  );
};

export default ErrorToast;
